import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m8 3.994 5.02 8.673H2.98L8 3.994Zm0-2.66L.667 14h14.666L8 1.334Zm.667 9.333H7.333V12h1.334v-1.333Zm0-4H7.333v2.667h1.334V6.667Z",
  fill: "#FB8C00"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };